import { useState } from 'react';

import { AppDownloadModal } from '../../AppDownloadModal/AppDownloadModal';
import { AppStoreButtons } from '../../Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { Button } from '../../Clickables/Buttons/Button';
import { Heading } from '../../Heading/Heading';
import { Text } from '../../Text/Text';

import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { trackEvent } from '@domain/analytics/trackEvent';
import DownloadAppMapDrawerCTABackground from './DownloadAppMapDrawerCTABackground.png';

export const DownloadAppMapDrawerCTA = () => {
  const { currentPage } = useAnalytics();
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);

  const downloadButtonClick = (): void => {
    trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        source: 'DownloadAppMapDrawerCTA',
        type: 'downloadModal',
        page: currentPage,
      },
    });
    setIsAppDownloadModalOpen(true);
  };
  return (
    <div
      style={{
        backgroundImage: `url(${DownloadAppMapDrawerCTABackground.src})`,
      }}
      className="flex w-full flex-col items-center rounded-md bg-cover py-6"
    >
      <Heading variant="xs" className="mx-10 text-center">
        See all fishing spots in the Fishbrain app
      </Heading>
      <Text variant="sm" className="px-7 pt-4 text-center">
        In the app you can see all catches in this area
      </Text>
      <Button onClick={downloadButtonClick} size="sm" className="hidden sm:flex">
        Download app
      </Button>
      <div className="flex w-full items-center justify-center sm:hidden">
        <AppStoreButtons orientation="vertical" source="DownloadAppMapDrawerCTA" />
      </div>
      <AppDownloadModal
        appDownloadSource="DownloadAppMapDrawerCTA"
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </div>
  );
};
